import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PartnerNavbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className="navbar" style={{ background: '#2e1a47' }}>
      <h1>Partner Portal</h1>
      <nav>
        <Link to="/partner" className={isActive('/partner')}>Dashboard</Link>
        <span style={{ color: '#888' }}>|</span>
        <span style={{ color: '#ccc' }}>{user?.company_name}</span>
        <button onClick={logout}>Logout</button>
      </nav>
    </div>
  );
}
